import type {
  GetRiskCountQuery,
  Risk_Bool_Exp,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type RiskCountArgs = {
  // Resolved entity-filter selection — drives the tRPC path (the data-layer
  // restricts the count(*) to risks under these entities). Empty/absent ⇒ no
  // entity filter.
  entityIds?: string[];
  // The equivalent Hasura bool_exp — drives the GraphQL fallback path so the
  // flag-gated twin counts identically. Built by useEntityWhereFilter.
  where?: Risk_Bool_Exp;
};

export const useGetRiskCount = createQueryHook<
  RiskCountArgs,
  number,
  GetRiskCountQuery
>({
  trpcQueryOptions: (trpc, queryArgs) =>
    trpc.frontend.risk.riskCount.queryOptions({
      entityIds: queryArgs?.entityIds,
    }),
  // Pass the count straight through (not `data ?? 0`): the factory surfaces
  // undefined while loading, so a genuine 0 must stay 0.
  mapTrpcDataToGraphQL: (data) => ({
    risk_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  graphqlDocument: GetRiskCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
